import { Component, ViewChild, ElementRef, Input } from '@angular/core';
import { ViewController, NavParams, Events } from 'ionic-angular';

// Providers 
import { InstructorsService } from '../../providers/instructors/instructors-service';
import { HelperService } from '../../providers/helpers/helper-service';

@Component({
  templateUrl: 'incident.modal.html'
})

export class IncidentModalPage
{
  edit: boolean = false;
  modalTitle: string = 'New Incident';
  incident: any = {};
  instructor: any = {};
  dateRange: any = {};

  constructor(
    public viewCtrl: ViewController,
    public navParams: NavParams,
    public instructorsService: InstructorsService,
    public helperService: HelperService,
    public events: Events
  ) {
    this.dateRange = this.helperService.getYearRange();
    let instructors = this.navParams.get('instructors');
    this.instructor = instructors[0];
    if ( this.navParams.get('edit') === true )
    {
      this.edit = true;
      this.modalTitle = 'Edit Incident';
      this.incident = this.navParams.get('editData');
    }
  }

  saveIncident()
  {
    this.incident.instructor_id = this.instructor.instructor_id;
    this.instructorsService.saveIncident( this.incident )
      .subscribe( data => {
        if ( this.edit === false )
        {
          this.instructor.incidents.push( data );
        }
        this.events.publish('app:log', {
          message: 'Instructor incident entry saved.',
          status: 'success',
          type: 'save instructor incident'
        });
    },
    error => {
      this.helperService.showErrors( error );
    });
    this.dismissModal();
  }

  dismissModal() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/incident.modal.ts